export default "__VITE_ASSET__ba037246__"